import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import Analytics from 'public/analytics.js';
import {memory} from 'wix-storage';

const intentToNavi = {
    "home": "/",
    "contact": "/contact",
    "checkout": "/cart",    // TODO: Can we checkout with API/URL?
    "help": "/contact",
    "about": "/contact",
    "sale": "/sale",
    "returns": "/returns-shipping",
    "shipping": "/returns-shipping",
    "campaign": "/new-arrivals",
    "new": "/new-arrivals",
    "shopping_cart": "/cart",   // No API to open mini-cart
    "brands": "/designers",
    // "more": "",
    // "add": "",
    // "remove": "",
    // "view": "",
}

const keywordToNavi = {
    "apostle club": "/appostle-club",
    // "asics": "/asics",
    "billionaire boys club": "/billionaire-boys-club",
    "born x raised": "/born-x-raised",
    "chinatown market": "/chinatown-market",
    "clae": "/clae",
    "clarks": "/clarks-originals",
    "corkcicle": "/corkcicle",
    "craft + foster": "/craft-foster",
    "druthers nyc": "/druthers-nyc",
    "evolve": "/evolve",
    "g-shock": "/g-shock",
    "g-star": "/g-star-raw",
    "herschel": "/herschel-supply-co",
    "honor the gift": "/honorthegift",
    "hypebeast": "/hypebeast",
    "ice cream": "/ice-cream",
    "jason markk": "/jason-markk",
    "john elliott": "/john-elliott",
    "ksubi": "/ksubi",
    "native youth": "/native-youth",
    "new balance": "/new-balance",
    // "new era": "",
    "penfield": "/penfield",
    "pleasures": "/pleasures",
    "publish": "/publish",
    "qilo nyc": "/qilo-nyc",
    "raen": "/raen",
    "rains": "/rains",
    "retrosuperfuture": "/retrosuperfuture",
    "reigning champ": "/reigning-champ",
    "rich and clean": "/the-rich-and-clean",
    "saturdays nyc": "/saturdays-nyc",
    "saucony": "/saucony",
    "stance": "/stance",
    "stampd": "/stampd",
    "stussy": "/stussy",
    "the unbranded brand": "/the-unbranded-brand",
    //"wax london": "",
    "wings + horns": "/wings-and-horns",
    "zanerobe": "/zanerobe",

    "designers": "/designers",

    "tops": "/tops",
    "shirts": "/button-ups",
    "t shirts": "/t-shirts",
    "hoodies": "/hoodies",
    "sweatshirts": "/sweatshirts",
    "outerwear": "/outerwear",

    "bottoms": "/bottoms",
    "denim": "/denim",
    "pants": "/pants",
    "shorts": "/shorts",

    "footwear": "/footwear",
    "shoes": "/shoes",
    "sneakers": "/sneakers",

    "footwear accessories": "/footwear-accessories",

    "accessories": "/accessories",
    "bags": "/bags",
    "headwear": "/headwear",
    "wallets": "/wallets",

    "eyewear": "/eyewear",

    "home & life": "/home-life",
    "men's grooming": "/men-s-grooming",
    "magazines": "/magazines",

    "gift cards": "/gift-cards",
    "socks": "/socks",
    "watches": "/watches"
}

export function startVoice() {
    // $w('#pushtotalk').setAttribute('appid', '28ab6277-903e-44aa-905d-0f00d240063a');

    if (!memory.getItem("oneTimeInit")) {
        memory.setItem("oneTimeInit", Date());
        Analytics.trackLaunch();
    }

    Analytics.page();

    // Show the button if initially hidden to prevent too early clicks
    // $w('#pushtotalk').setAttribute('hide', 'false');

    $w('#pushtotalk').on('starting', (event) => {
        Analytics.trackStarting();
	});

    $w('#pushtotalk').on('initialized', (event) => {
        Analytics.trackInitialized(event.detail.success, event.detail.status);
	});

    $w('#pushtotalk').on('speechsegment', (event) => {
		const segment = event.detail;

        // Act only on final segments
        if (!segment.isFinal) return;

        console.log(segment);

        let handled = false;

        if (!handled) handled = handleIntentNavi(segment)
        if (!handled) handled = handleLandingPageNavi(segment)
        if (!handled) handled = handleSearch(segment)
    });
}

function acknowledged() {
    wixWindow.postMessage({type: "speechhandled", success: true});
}

function handleIntentNavi(segment) {
    if (!segment.intent.intent) return false;

    if (intentToNavi[segment.intent.intent]) {
        wixLocation.to(intentToNavi[segment.intent.intent]);
        console.log("handleIntentNavi intent: ", segment.intent.intent, intentToNavi[segment.intent.intent])

        if (segment.isFinal) {
            acknowledged();
            Analytics.trackSpeechlyAction("Voice Navi", segment.intent.intent);
            Analytics.trackSpeechlyQA("Voice Navi: "+segment.intent.intent, segment);
        }

        return true;
    }
    return false;
}

function handleLandingPageNavi(segment) {
    // Ensure we have the right intent(ions;)
    switch (segment.intent.intent) {
        case "search":
        case "refine_search":
            break;
        default:
            return false;
    }

    // No handling multiple entities; handleSearch is for that
    if (segment.entities.length > 1) return false;

    let bestScore = 0;
    let candidate = null;
    for (let i = 0; i < segment.entities.length; i++) {
        const keyword = segment.entities[i].value.toLowerCase();
        const data = keywordToNavi[keyword];
        let candidateScore = 0;
        if (data) {
            candidateScore = 1;
        }
        if (candidateScore > bestScore) {
            candidate = {
                keyword,
                data: data,
                entity: segment.entities[i]
            }
            bestScore = candidateScore;
        }
    }

    if (candidate) {
        wixLocation.to(candidate.data);
        console.log("handleLandingPageNavi")

        if (segment.isFinal) {
            acknowledged();
            Analytics.trackSpeechlyAction("Voice Impression", candidate.keyword);
            Analytics.trackSpeechlyQA("Voice Impression: "+candidate.keyword, segment);
        }

        return true;
    }

    return false;
}

function handleSearch(segment) {
    // Ensure we have the right intent(ions;)
    switch (segment.intent.intent) {
        case "search":
        case "refine_search":
            break;
        default:
            return false;
    }

    const value = segment.entities.map(entity => entity.value).join(" ")

    if (value !== "") {
        // $w('#searchBox1').value = value
        wixLocation.to('/search-results/q-' + encodeURIComponent(value) + '/qc-products');
        console.log("handleSearch")

        if (segment.isFinal) {
            acknowledged();
            Analytics.trackSpeechlyAction("Voice Search", value);
            Analytics.trackSpeechlyQA("Voice Search: "+value, segment);
        }
    }

    return true;
}